<script>
    import { ReplaceEnter } from '../../script/_validator'
    export let Date, Nick, Build, Test, Blank, Memo, View

    let leftHeight, rightHeight, barHeight
    $:if(leftHeight>rightHeight)
        {barHeight=leftHeight} else {barHeight=rightHeight}
</script>

<div class='info'>
    <div class="cell" bind:clientHeight={leftHeight}>
        <div class="row">
            <div class="tag">작성일자 : </div> {Date}
        </div>

        <div class="row">
            <div class="tag">닉네임 : </div> {Nick}
        </div>

        <div class="row">
            <div class="tag">
                메모 : 
            </div><br>
            {@html ReplaceEnter(Memo)}
        </div>
    </div>

    <div class="bar" style="height:{barHeight-100}px;"></div>

    <div class="cell" bind:clientHeight={rightHeight}>
        <div class="row">
            <div class="tag">버전 : </div> Build 00{Build}
        </div>

        <div class="row">
            <div class="tag">조회수 : </div> {View}
        </div>

        <div class="row">
            {#if Test}
                <div class="tag">테스트 여부 : </div>
                <strong>테스트 게시글</strong>
            {/if}
        </div>

        <div class="row">
            {#if Blank}
                <div class="tag">공백 여부 : </div> 
                <strong>일부 공백</strong>
            {/if}
        </div>
    </div>
</div>

<style lang="scss">
    .info {
        width: 100%;
        height: fit-content;

        .cell {
            width:calc(50% - 100.5px);
            padding: 50px;
            padding-bottom: 26px;
            display: inline-block;
            vertical-align: top;
        }

        .row {
            margin-bottom: 24px;
            font-size: 15px;
            word-break:break-all;

            .tag {
                color: $cl3;
                font-family: aggro;
                display: inline-block;
            }

            strong {
                color: $cl4;
            }
        }

        .bar {
            content: "";
            background: $cl3;
            width: 1px;
            /*min-height: 200px;*/
            margin: 50px 0;
            display: inline-block;
        }
        
        @include mobile {
            .cell {
                width:calc(50% - 30.5px);
                padding: 20px 15px 6px 15px;
            }
            .row {
                margin-bottom: 14px;
                font-size: 12px;

                .tag {
                    display: block;
                }
            }
        }
    }
</style>